export class ProjectDataScheme {
    public x: number = -10000;
    public y: number = -10000;
    public scale: number = 1;
}